import React from 'react';
import { Leaf, MapPin, Heart, Shield } from 'lucide-react';

interface Feature {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: Leaf,
    title: 'Eco-Friendly',
    description: '100% organic and sustainable farming practices',
  },
  {
    icon: MapPin,
    title: 'Locally Sourced',
    description: 'Direct from farmers across Nepal',
  },
  {
    icon: Heart,
    title: 'Sustainable Farming',
    description: 'Supporting local communities and preserving nature',
  },
  {
    icon: Shield,
    title: 'Quality Guaranteed',
    description: 'Certified organic products you can trust',
  },
];

export const WhyChooseUs: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-poppins">
            Why Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're committed to bringing you the best organic products while supporting local farmers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-soft border border-gray-100 text-center hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#E8F5E9]/30 rounded-full mb-6">
                  <IconComponent className="w-8 h-8 text-[#2E7D32]" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3 font-poppins">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

